import useSWR, { SWRConfiguration } from 'swr';
import { StockOnHand } from '~/types';

const key = '/api/stock-on-hand?';

export const useStockOnHand = (
  query?: string,
  options?: SWRConfiguration<StockOnHand[]>
) => {
  const url = query ? key + query : key;
  return useSWR<StockOnHand[]>(url, options);
};
